import { I18n } from '@calendly/i18n'

export const getSummary = ({ dailyLimit, weeklyLimit, monthlyLimit }) => {
  if (!dailyLimit && !weeklyLimit && !monthlyLimit) {
    return I18n.t('publisher.event_type_editor.sections.scheduling_settings.not_set')
  }

  const dailyLimitSummary = dailyLimit
    ? `${dailyLimit}/${I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.max_meetings.summary.day')}`
    : null

  const weeklyLimitSummary = weeklyLimit
    ? `${weeklyLimit}/${I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.max_meetings.summary.week')}`
    : null

  const monthlyLimitSummary = monthlyLimit
    ? `${monthlyLimit}/${I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.max_meetings.summary.month')}`
    : null

  return [dailyLimitSummary, weeklyLimitSummary, monthlyLimitSummary].filter(Boolean).join(', ')
}
